import React, { useState } from 'react';
import { Box, Select, Text, useColorModeValue, VStack } from '@chakra-ui/react';

import { AdminLayout, Card } from '@grcs/components';

import { VocTable } from '@grcs/views/shared/components/tables/DataTable';

interface GlossaryData {
  [grade: string]: string[];
}

interface ToolsProps {
  active?: boolean;
  embedded?: boolean;
}

export const GlossaryEnhanced: React.FC<ToolsProps> = ({
  active = true,
  embedded = false,
}) => {
  const Layout = embedded ? Box : AdminLayout;
  const muted = useColorModeValue('gray.600', 'gray.300');
  const supportedGlossaries = [
    { label: 'GRCS', value: 'GRCS' },
    { label: 'HSK', value: 'HSK' },
  ];

  const [selectedList, setSelectedList] = useState<string>('');
  const [glossary, setGlossary] = useState<GlossaryData>();

  // Load dictionary data
  const hanziList: Record<
    string,
    string
  > = require('@grcs/dictionary/hanzi_list.json');
  const hsk500: Record<
    string,
    string[]
  > = require('@grcs/dictionary/hsk_list.json');

  const handleListSelection = (listName: string) => {
    setSelectedList(listName);

    let newHanziList: GlossaryData = {};
    const selectList = listName === 'GRCS' ? hanziList : hsk500;
    for (const [key, list] of Object.entries(selectList)) {
      newHanziList[key] = list.split('');
    }
    setGlossary(newHanziList);
  };

  return (
    <Layout padding={embedded ? 0 : 3}>
      <VStack spacing={4} align="stretch">
        <Box>
          <Text fontSize="sm" color={muted} mb={3}>
            Choose a character list to browse vocabulary by level.
          </Text>
          <Select
            size="sm"
            maxW={{ md: '320px' }}
            borderRadius="md"
            aria-label="Character list"
            value={selectedList}
            onChange={(event) => handleListSelection(event.target.value)}
          >
            <option value="" disabled>
              Select a character list
            </option>
            {supportedGlossaries.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Select>
        </Box>
        {selectedList && glossary ? (
          <Card padding={3} variant="outline" overflowX="auto">
            <VocTable key_name="等级" value_name="字表" data={glossary} />
          </Card>
        ) : (
          <Text fontSize="sm" color={muted} textAlign="center" py={8}>
            Select GRCS or HSK above to view its characters.
          </Text>
        )}
      </VStack>
    </Layout>
  );
};
